
const digest = '7c7b3e36892ff1bbd3d76566409a40d7f744508f61be7f9e1afcfa7f03dcee25';
const classes = {"item":"_item_129nw_1","date":"_date_129nw_13","content":"_content_129nw_19","title":"_title_129nw_25","controls":"_controls_129nw_29"};
const css = `._item_129nw_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_129nw_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._item_129nw_1 ._date_129nw_13 {
  font-size: 14px;
  color: #000000;
  min-width: 150px;
  max-width: 150px;
}
._item_129nw_1 ._content_129nw_19 {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 5px;
}
._item_129nw_1 ._content_129nw_19 ._title_129nw_25 {
  color: #000000;
  font-weight: 500;
}
._item_129nw_1 ._controls_129nw_29 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  